import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@unico-people/shared/dashboard/data-access-auth';
import { DataAccessCallbackService } from '@unico-people/shared/dashboard/data-access-callback';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { SessionStorage, setCsrfToken, setTokenStorage } from '@unico-people/shared/utils/storage';

import { retry, timeout } from 'rxjs/operators';

@Component({
  selector: 'up-feature-callback',
  templateUrl: './feature-callback.component.html',
  styleUrls: ['./feature-callback.component.scss']
})
export class FeatureCallbackComponent implements OnInit {
  targetRedirect: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private callbackService: DataAccessCallbackService,
    private authService: AuthService,
    private trackingService: TrackingSegmentService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => (this.targetRedirect = data?.roles));
    this.route.queryParams.subscribe(params => {
      this.getToken(params?.code);
    });
  }

  getToken(code: string): void {
    this.callbackService
      .getToken(code, this.targetRedirect)
      .pipe(timeout(6000), retry(7))
      .subscribe(
        response => {
          const { token } = response;
          setTokenStorage(token);
          this.getAuthorization(token);
        },
        () => this.authService.logout(this.route?.snapshot?.data?.roles)
      );
  }

  getAuthorization(token: string): void {
    this.callbackService
      .getAuthorization(token)
      .pipe(timeout(6000), retry(7))
      .subscribe(
        response => {
          const { name, email, id, organization, organizationName } = response?.body;

          SessionStorage.setItem('user', {
            user_name: name,
            user_email: email,
            user_id: id
          })

          this.trackingService.identify(id, { organization_name: organizationName });
          SessionStorage.setItem('organization', organization);
          SessionStorage.setItem('organizationName', organizationName);


          const csrf_token = response?.headers?.get('acesso-csrf-token');
          setCsrfToken(csrf_token);

          const pathsRedirect = {
            'benefits': () => this.router.navigate(['/']),
            'productivity': () =>  this.router.navigate(['/productivity']),
            'eligibility': () => this.router.navigate(['/eligibility'])
          }

          if(this.targetRedirect) {
            pathsRedirect[this.targetRedirect]();
          }
        },
        () => this.authService.logout(this.route?.snapshot?.data?.roles)
      );
  }
}
